import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, takeUntil, catchError } from 'rxjs/operators';

import { trackById } from 'v2/modules/shared/util/track-by.util';

// INTERFACES
import {
  LocalStorageKeys,
  BomApiService,
  OptionInterface,
  SnackBarConfig,
} from '../../../shared';
import { IBom } from '../../interfaces/bom.interface';

@Component({
  selector: 'lum-bom-details',
  templateUrl: './bom-details.component.html',
  styleUrls: ['./bom-details.component.scss'],
})
export class BomDetailsComponent implements OnInit, OnDestroy {
  bomId :number = 0;

  loading :boolean = false;

  bom :IBom;
  trackById = trackById;

  private onDestroy$ = new Subject();

  constructor(
    private bomApiService :BomApiService,
    private route :ActivatedRoute,
    private cd :ChangeDetectorRef,
    private snackBar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    this.getRouterParams().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  private loadBom(bomId :number) :void {
    this.loading = true;
    this.bomApiService
      .getById(bomId, {
        relations: 'items|items.rfq.unitOfMeasures|items.unitOfMeasure',
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.bom = response;
          this.cd.detectChanges();
        },
        error: (response) => {
          this.loading = false;
          this.snackBar.open(response.error, 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.cd.detectChanges();
        },
      });
  }

  private getRouterParams() :Observable<Params> {
    return this.route.params.pipe(
      tap((params :Params) => {
        const { bomId } = params;
        if (bomId) {
          this.bomId = bomId;
          this.loadBom(this.bomId);
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }
}
